import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import ArticlePage from './views/ArticlePage.vue'
import AdminArticles from './views/AdminArticles.vue'
import PageNotFound from './views/PageNotFound.vue'
import PageForbidden from './views/PageForbidden.vue'
import CalendarPage from './views/CalendarPage.vue'
import AdminCourses from './views/AdminCourses.vue'
import AdminKlasses from './views/AdminKlasses.vue'
import AdminEditCourses from './views/AdminEditCourse.vue'
import AdminEditKlasses from './views/AdminEditKlass.vue'

import store from './store';

Vue.use(Router)

function setTitle(to) {
  if (to.name) {
    const classUrl = location.hostname.split('.')[0];
    if (to.name == 'home') {
      document.title = `${classUrl} Node Hill`.trim();
    } else {
      // Show entire route-name
      // const routeName = (to.name[0].toUpperCase() + to.name.substr(1)).replace(/([A-Z]{1})/g, ' $1').trim();

      // Show first word in route-name
      const routeName = to.name[0].toUpperCase() + to.name.substr(1).split(/[A-Z]/g)[0];

      const articleSlug = to.params.slug || '';
      document.title = `${classUrl} ${articleSlug} ${routeName}  Node Hill`.trim();
    }
  }
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    // returning falsey still scrolls to top - why?
    if (to.matched.some(m => m.meta.disableScroll)) return;
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(savedPosition || { x: 0, y: 0 })
      }, 500)
    })
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/admin-articles',
      name: 'adminArticles',
      component: AdminArticles
    },
    {
      path: '/admin/courses',
      name: 'adminCourses',
      component: AdminCourses
    },
    {
      path: '/admin/klasses',
      name: 'adminKlasses',
      component: AdminKlasses
    },
    {
      path: '/admin/klasses/:slug?/edit',
      name: 'adminEditKlass',
      component: AdminEditKlasses
    },
    {
      path: '/admin/courses/:slug?/edit',
      name: 'adminEditCourse',
      component: AdminEditCourses
    },
    {
      path: '/create-article/:slug?',
      name: 'createArticle',
      component: () => import(/* webpackChunkName: "createArticle" */ './views/CreateArticle.vue')
    },
    {
      path: '/article/:slug',
      name: 'article',
      component: ArticlePage,
      meta: { disableScroll: true }
    },
    {
      path: '/calendar/:view?/:year?/:month?/:day?',
      name: 'calendar',
      component: CalendarPage,
      meta: { disableScroll: true }
    },
    {
      path: '/forbidden',
      name: 'pageForbidden',
      component: PageForbidden
    },
    {
      path: '*',
      name: 'pageNotFound',
      component: PageNotFound
    }
  ]
});

router.beforeEach(async (to, from, next) => {
   const isLoggedIn = await store.dispatch("whoami");

  const isAdmin = store.getters.isAdmin;
  if (isAdmin) {
    setTitle(to);
    return next();
  }

  const adminPage = [
    'adminArticles', 'createArticle', 'adminCourses', 'adminKlasses',
    'adminEditKlass', 'adminEditCourse'
  ].includes(to.name);
  const loggedInPage = ['calendar'].includes(to.name);

  if ((adminPage && !isAdmin) || (loggedInPage && !isLoggedIn)) {
    return next('forbidden');
  }
  setTitle(to);
  next();
})


export default router;
